module.exports = __webpack_public_path__ + "static/media/logo_eventline.684bc51f.png";